import { IconAffiliate } from '@tabler/icons-react';

/** Ícone Tabler "affiliate" — marca Customers (config + sidebar). */
export default function CustomersAffiliateIcon({
  size = 18,
  stroke = 1.75,
  className,
  ...rest
}) {
  return (
    <IconAffiliate
      size={size}
      stroke={stroke}
      className={className}
      aria-hidden={rest['aria-hidden'] ?? true}
      {...rest}
    />
  );
}
